export default {
    // Header Section
    "discover_your": "अपने",
    "gemstones": "रत्न",
    "healing_crystal_guidance": "उपचार क्रिस्टल मार्गदर्शन",
    "gemstones_description": "अपनी अनूठी जन्म कुंडली के आधार पर व्यक्तिगत रत्न और क्रिस्टल सिफारिशें प्राप्त करें। उपचार, सुरक्षा, समृद्धि और आध्यात्मिक विकास के लिए सही पत्थरों की खोज करें—साथ ही उनके अधिकतम लाभ के लिए चुनने, पहनने और देखभाल करने के विशेषज्ञ मार्गदर्शन के साथ।",

    "gemstone_power": "शक्तियों को खोलें",
    "unlock_your": "अपनी रत्न",

    // Service Information
    "enter_details_for_gemstone_analysis": "रत्न विश्लेषण के लिए अपना विवरण दर्ज करें",
    "complete_gemstone_analysis": "संपूर्ण रत्न विश्लेषण",
    "service_price": "सेवा मूल्य",
    "comprehensive_gemstone_analysis_note": "ग्रहीय विश्लेषण और पहनने के मार्गदर्शन के साथ व्यक्तिगत रत्न सिफारिशें",

    // Form Fields
    "full_name": "पूरा नाम",
    "enter_full_name": "अपना पूरा नाम दर्ज करें",
    "name_gemstone_resonance": "आपके नाम की तरंगें रत्न की गूंज और अनुकूलता निर्धारित करने में मदद करती हैं",
    "email_address": "ईमेल पता",
    "enter_email_address": "अपना ईमेल पता दर्ज करें",
    "phone_number": "फोन नंबर",
    "enter_phone_number": "अपना फोन नंबर दर्ज करें",
    "gender": "लिंग",
    "male": "पुरुष",
    "female": "स्त्री",
    "other": "अन्य",
    "date_of_birth": "जन्म तिथि",
    "birth_date_planetary_gemstones": "ग्रहीय प्रभाव और उपयुक्त रत्न निर्धारित करने के लिए आवश्यक",
    "time_of_birth": "जन्म समय",
    "exact_time_gemstone_selection": "सटीक ग्रहीय शक्ति विश्लेषण के लिए सटीक समय आवश्यक",
    "place_of_birth": "जन्म स्थान",
    "place_of_birth_placeholder": "शहर, राज्य, देश",
    "location_affects_gemstone_energy": "स्थान रत्न चयन को प्रभावित करने वाली ग्रहीय स्थितियों को प्रभावित करता है",
    "preferred_language": "पसंदीदा भाषा",
    "english": "अंग्रेजी",
    "hindi": "हिंदी",
    "telugu": "तेलुगू",
    "kannada": "कन्नड़",
    "language_note": "आपकी रत्न गाइड चुनी गई भाषा में प्रदान की जाएगी",

    // Core Gemstone Features
    "personalized_gemstone_recommendations": "व्यक्तिगत रत्न सिफारिशें",
    "planetary_gemstone_analysis": "ग्रहीय रत्न विश्लेषण",
    "healing_crystal_guidance": "उपचार क्रिस्टल मार्गदर्शन",
    "wearing_methods_timing": "पहनने की विधि और समय",
    "gemstone_care_instructions": "रत्न देखभाल निर्देश",
    "pdf_download": "व्यापक पीडीएफ गाइड",

    "what_you_get": "आपके रत्न विश्लेषण में क्या शामिल है",
    "personalized_gemstone_guide": "व्यक्तिगत रत्न गाइड",
    "planetary_remedial_stones": "ग्रहीय उपचारात्मक पत्थर",
    "healing_crystal_recommendations": "उपचार क्रिस्टल सिफारिशें",
    "wearing_activation_guidance": "पहनने और सक्रियकरण मार्गदर्शन",

    // Actions & Buttons
    "pay_and_get_gemstone_guidance": "मेरी रत्न गाइड प्राप्त करें",
    "processing_payment": "भुगतान प्रसंस्करण",
    "processing_request": "गाइड तैयार की जा रही है",

    // Payment & Success Messages
    "thank_you": "धन्यवाद",
    "payment_successful": "भुगतान सफल!",
    "gemstone_analysis_processing": "आपका व्यक्तिगत रत्न विश्लेषण हमारे विशेषज्ञ रत्न विशेषज्ञों और ज्योतिषियों द्वारा तैयार किया जा रहा है। आपको उपचार और उपचारात्मक पत्थरों की विस्तृत सिफारिशें प्राप्त होंगी।",
    "order_id": "ऑर्डर आईडी",
    "payment_id": "भुगतान आईडी",
    "amount_paid": "भुगतान की गई राशि",

    // Delivery Information
    "delivery_information": "डिलीवरी जानकारी",
    "delivery_time": "गाइड डिलीवरी",
    "within_12_hours_delivery_note": "आपकी विस्तृत रत्न गाइड 12 घंटों के भीतर तैयार हो जाएगी",
    "whatsapp_notification": "व्हाट्सऐप अपडेट",
    "whatsapp_delivery_note": "व्हाट्सऐप पर तुरंत सूचनाएं प्राप्त करें",
    "email_delivery": "ईमेल डिलीवरी",
    "email_delivery_note": "पूरी गाइड इस पर भेजी गई",

    // What You'll Receive
    "what_youll_receive": "आपका रत्न गाइड पैकेज",
    "detailed_gemstone_report_pdf": "विस्तृत रत्न रिपोर्ट (पीडीएफ)",
    "personalized_stone_recommendations": "व्यक्तिगत पत्थर सिफारिशें",
    "planetary_remedial_guidance": "ग्रहीय उपचारात्मक मार्गदर्शन",
    "wearing_activation_methods": "पहनने और सक्रियकरण विधियां",
    "gemstone_care_maintenance": "रत्न देखभाल और रखरखाव",

    // Visual Content
    "sample_gemstone_analysis": "नमूना रत्न विश्लेषण",
    "recommended_gemstone": "अनुशंसित रत्न",
    "sample_gemstone_reading": "शनि को मजबूत करने और बुद्धि वृद्धि के लिए नीलम",
    "sample_gemstone_preview": "उपचार गुणों के साथ आपकी व्यक्तिगत रत्न सिफारिशों का पूर्वावलोकन",
    "gemstone_categories": "रत्न श्रेणियां",

    // Gemstone Types
    "ruby": "माणिक",
    "emerald": "पन्ना",
    "sapphire": "नीलम",
    "diamond": "हीरा",
    "yellow_sapphire": "पुखराज",
    "coral": "मूंगा",

    // Status & Processing
    "your_gemstone_analysis_status": "आपके रत्न विश्लेषण की स्थिति",
    "processing_your_analysis": "आपकी रत्न आवश्यकताओं का विश्लेषण",
    "analysis_processing_message": "हमारे विशेषज्ञ रत्न विशेषज्ञ उपचार, सुरक्षा और समृद्धि के लिए सबसे उपयुक्त रत्नों की सिफारिश करने के लिए आपकी जन्म कुंडली का अध्ययन कर रहे हैं।",
    "request_id": "विश्लेषण आईडी",
    "status": "स्थिति",
    "processing": "प्रगति में",
    "pending": "कतार में",
    "email_notification_sent": "पुष्टिकरण ईमेल भेजा गया",
    "whatsapp_update_coming": "व्हाट्सऐप अपडेट सक्षम",
    "delivery_within_12_hours": "गाइड 12 घंटों के भीतर तैयार",

    // Support & Contact
    "contact_support": "रत्न सहायता से संपर्क करें",
    "need_help": "मार्गदर्शन चाहिए?",
    "contact_us_at": "हमसे संपर्क करें",

    // Error Messages
    "please_fill_all_required_fields": "कृपया सभी आवश्यक जन्म विवरण पूरा करें",
    "payment_failed": "भुगतान असफल। कृपया पुनः प्रयास करें।",
    "processing_failed": "विश्लेषण प्रसंस्करण असफल। हमारी सहायता टीम से संपर्क करें।",

    // Planetary Gemstones
    "sun_gemstones": "सूर्य रत्न",
    "moon_gemstones": "चंद्र रत्न",
    "mars_gemstones": "मंगल रत्न",
    "mercury_gemstones": "बुध रत्न",
    "jupiter_gemstones": "बृहस्पति रत्न",
    "venus_gemstones": "शुक्र रत्न",
    "saturn_gemstones": "शनि रत्न",
    "rahu_gemstones": "राहु रत्न",
    "ketu_gemstones": "केतु रत्न",

    // Primary Gemstones
    "ruby_manik": "माणिक (माणिक)",
    "pearl_moti": "मोती (मोती)",
    "coral_moonga": "लाल मूंगा (मूंगा)",
    "emerald_panna": "पन्ना (पन्ना)",
    "yellow_sapphire_pukhraj": "पुखराज (पुखराज)",
    "diamond_heera": "हीरा (हीरा)",
    "blue_sapphire_neelam": "नीलम (नीलम)",
    "hessonite_gomed": "गोमेद (गोमेद)",
    "cats_eye_lehsunia": "लहसुनिया (लहसुनिया)",

    // Secondary Gemstones
    "garnet": "गार्नेट",
    "moonstone": "चांदनी पत्थर",
    "carnelian": "कार्नेलियन",
    "peridot": "पेरिडॉट",
    "citrine": "सिट्रिन",
    "opal": "ओपल",
    "amethyst": "जमुनिया",
    "agate": "अकीक",
    "onyx": "गोमेद",

    // Healing Crystals
    "rose_quartz": "गुलाबी क्वार्ट्ज",
    "clear_quartz": "स्पष्ट क्वार्ट्ज",
    "amethyst_crystal": "जमुनिया क्रिस्टल",
    "citrine_crystal": "सिट्रिन क्रिस्टल",
    "black_tourmaline": "काला टूमलाइन",
    "green_aventurine": "हरा एवेंट्यूरिन",
    "tigers_eye": "बाघ की आंख",
    "labradorite": "लैब्राडोराइट",
    "fluorite": "फ्लोराइट",

    // Gemstone Properties
    "healing_properties": "उपचार गुण",
    "protective_properties": "सुरक्षात्मक गुण",
    "prosperity_properties": "समृद्धि गुण",
    "spiritual_properties": "आध्यात्मिक गुण",
    "emotional_properties": "भावनात्मक उपचार गुण",
    "physical_properties": "शारीरिक उपचार गुण",

    // Gemstone Selection Criteria
    "planetary_strength": "ग्रहीय शक्ति विश्लेषण",
    "weak_planets": "कमजोर ग्रहों की पहचान",
    "malefic_planets": "पाप ग्रहों का विश्लेषण",
    "benefic_enhancement": "शुभ ग्रह वृद्धि",
    "doshas_correction": "दोष सुधार",
    "yogas_strengthening": "योग सुदृढ़ीकरण",

    // Quality & Authenticity
    "gemstone_quality": "रत्न गुणवत्ता दिशा-निर्देश",
    "authenticity_check": "प्रामाणिकता सत्यापन",
    "certification_importance": "प्रमाणन महत्व",
    "natural_vs_synthetic": "प्राकृतिक बनाम कृत्रिम पत्थर",
    "treatment_disclosure": "उपचार और वृद्धि प्रकटीकरण",
    "origin_significance": "मूल और स्रोत महत्व",

    // Wearing Guidelines
    "wearing_finger": "पहनने की उंगली मार्गदर्शन",
    "wearing_day": "शुभ पहनने का दिन",
    "wearing_time": "इष्टतम पहनने का समय",
    "metal_selection": "सेटिंग के लिए धातु चयन",
    "weight_calculation": "रत्न वजन गणना",
    "purification_ritual": "शुद्धिकरण और सक्रियकरण अनुष्ठान",

    // Gemstone Care
    "cleaning_methods": "सफाई और रखरखाव विधियां",
    "storage_guidelines": "उचित भंडारण दिशा-निर्देश",
    "energizing_techniques": "पुनः ऊर्जा देने की तकनीकें",
    "avoid_damage": "क्षति रोकथाम सुझाव",
    "periodic_cleansing": "नियमित सफाई अनुष्ठान",
    "replacement_timing": "प्रतिस्थापन और उन्नयन समय",

    // Benefits & Effects
    "career_benefits": "करियर और व्यापार लाभ",
    "health_benefits": "स्वास्थ्य और कल्याण लाभ",
    "relationship_benefits": "रिश्ते और प्रेम लाभ",
    "financial_benefits": "वित्तीय और समृद्धि लाभ",
    "spiritual_benefits": "आध्यात्मिक विकास लाभ",
    "protection_benefits": "सुरक्षा और संरक्षण लाभ",

    // Timing & Muhurat
    "auspicious_timing": "शुभ खरीदारी समय",
    "wearing_muhurat": "पहनने का मुहूर्त गणना",
    "activation_timing": "सक्रियकरण अनुष्ठान समय",
    "eclipse_precautions": "ग्रहण काल सावधानियां",
    "festival_significance": "त्योहार और विशेष दिन महत्व",
    "monthly_guidelines": "मासिक पहनने के दिशा-निर्देश",

    // Combination Guidelines
    "gemstone_combinations": "लाभकारी रत्न संयोजन",
    "conflicting_stones": "विरोधी पत्थर संयोजन",
    "layered_wearing": "स्तरित पहनने के दिशा-निर्देश",
    "rotation_schedule": "रत्न रोटेशन अनुसूची",
    "seasonal_preferences": "मौसमी रत्न प्राथमिकताएं",
    "occasion_selection": "अवसर आधारित चयन",

    // Alternative Options
    "budget_alternatives": "बजट-अनुकूल विकल्प",
    "substitute_stones": "विकल्पी पत्थर विकल्प",
    "semi_precious_options": "अर्ध-कीमती विकल्प",
    "synthetic_alternatives": "कृत्रिम पत्थर विकल्प",
    "crystal_alternatives": "क्रिस्टल और खनिज विकल्प",
    "rudraksha_combinations": "रुद्राक्ष संयोजन",

    // Special Categories
    "bridal_gemstones": "दुल्हन रत्न चयन",
    "childrens_gemstones": "बच्चों के रत्न दिशा-निर्देश",
    "elderly_recommendations": "बुजुर्गों के लिए विशिष्ट सिफारिशें",
    "professional_stones": "व्यावसायिक और करियर पत्थर",
    "students_gemstones": "छात्र और शैक्षणिक पत्थर",
    "artists_stones": "रचनात्मक और कलात्मक पत्थर",

    // Astrological Factors
    "ascendant_stones": "लग्न आधारित पत्थर चयन",
    "moon_sign_stones": "चंद्र राशि रत्न मार्गदर्शन",
    "sun_sign_influence": "सूर्य राशि चयन पर प्रभाव",
    "navamsa_considerations": "नवमांश चार्ट विचारणा",
    "dasha_period_stones": "दशा काल विशिष्ट पत्थर",
    "transit_considerations": "वर्तमान गोचर विचारणा",

    // Consultation Features
    "expert_consultation": "विशेषज्ञ रत्न विशेषज्ञ परामर्श",
    "follow_up_guidance": "अनुवर्ती मार्गदर्शन उपलब्ध",
    "customization_options": "अनुकूलन और व्यक्तिगतकरण",
    "update_recommendations": "अद्यतन सिफारिशें",
    "progress_tracking": "लाभ प्रगति ट्रैकिंग",
    "adjustment_guidance": "समायोजन और बारीक-धुनी",

    // Regional Preferences
    "indian_gemstones": "भारतीय मूल रत्न",
    "burmese_stones": "बर्मी मूल पत्थर",
    "ceylon_sapphires": "सीलोन नीलम विशेषता",
    "kashmir_sapphires": "कश्मीरी नीलम प्रीमियम",
    "colombian_emeralds": "कोलंबियाई पन्ना उत्कृष्टता",
    "african_gemstones": "अफ्रीकी मूल रत्न",

    // Modern Applications
    "technology_enhancement": "प्रौद्योगिकी और डिजिटल जीवन वृद्धि",
    "stress_relief": "आधुनिक तनाव राहत समाधान",
    "urban_living": "शहरी जीवन रत्न आवश्यकताएं",
    "travel_protection": "यात्रा और यात्रा सुरक्षा",
    "workspace_harmony": "कार्यक्षेत्र सामंजस्य पत्थर",
    "social_confidence": "सामाजिक आत्मविश्वास बूस्टर"
};
